module.exports = __webpack_public_path__ + "img/logo19.b0cea8ae.jpg";